/**
 * © 2026 iTech India Private Limited. All rights reserved.
 * Licensed under the iTech End User License Agreement (EULA).
 * Unauthorized use or distribution is prohibited.
 */

import { type JSX } from 'react';

import { InvoicesView } from '../finance/invoices-view.js';

import { FinanceOverview } from './finance-overview.js';

/**
 * Admin → Finance (Figma). The overview band (gradient metric cards + outstanding
 * invoices with Send Reminder) sits above the full invoice management surface
 * (New Invoice + record payment + search), so no functionality is lost.
 */
export function AdminFinancePage(): JSX.Element {
  return (
    <div>
      <div className="px-8 pt-8">
        <FinanceOverview />
      </div>
      <InvoicesView
        titleKey="admin.finance.allInvoices"
        subtitleKey="admin.finance.count"
        canManage
      />
    </div>
  );
}
